@if (dataSourceCurrentYear) {
  <div class="table-container">
    <h3 class="table-header">{{ currentYearLabel }}</h3>
    <table mat-table class="rates-table mat-elevation-z6" [dataSource]="dataSourceCurrentYear">
      <ng-container matColumnDef="planName" class="plan-name">
        <mat-header-cell *matHeaderCellDef>Plans</mat-header-cell>
        <mat-cell *matCellDef="let rate">
          {{rate.planName}}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="subsidy_100">
        <mat-header-cell *matHeaderCellDef>At 100%</mat-header-cell>
        <mat-cell *matCellDef="let rate">
          {{rate.subsidy_100 | lisDisplayPipe }}
        </mat-cell>
      </ng-container>
      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
    </table>
  </div>
}

@if (dataSourceNextYear && showNextYearsPlans) {
  <div class="table-container">
    <h3 class="table-header">{{ nextYearLabel }}</h3>
    <table mat-table class="rates-table mat-elevation-z6" [dataSource]="dataSourceNextYear">
      <ng-container matColumnDef="planName">
        <mat-header-cell *matHeaderCellDef>Plans</mat-header-cell>
        <mat-cell *matCellDef="let rate">
          {{rate.planName}}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="subsidy_100">
        <mat-header-cell *matHeaderCellDef>At 100%</mat-header-cell>
        <mat-cell *matCellDef="let rate">
          {{rate.subsidy_100 | lisDisplayPipe }}
        </mat-cell>
      </ng-container>
      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
    </table>
  </div>
}

@if (!dataSourceCurrentYear && !dataSourceNextYear) {
  <div class="no-table-message">
    The Low Income Subsidy (LIS) rates will be coming soon
  </div>
}

@if (showSpinner) {
  <mat-spinner [diameter]="100"></mat-spinner>
}
